import { EvPlugCcs2Icon } from './EvPlugCcs2Icon';

/**
 * author: Michael Irigoyen
 * id 4FE92E92-170B-495E-A16E-0897AD787E02
 * name ev-plug-ccs2
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ev-plug-ccs2.svg
 * tags
 * - Automotive 
 */
export const EvChargerCcs2Icon = EvPlugCcs2Icon;
export default EvChargerCcs2Icon